import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveUserTemplates(context, companyId) {
      try {
        const templates = await axios.get(`/user-template/${companyId}`, { withCredentials: true });
        return templates.data;
      } catch (error) {
        throw error;
      }
    },
    async createUserTemplate(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post('/user-template', data.newTemplate, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async updateUserTemplate(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.patch(`/user-template/${data.companyId}`, data.data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
